"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteNodeModal = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const partials_1 = require("../partials");
const delete_node_modal_styles_1 = require("./delete-node-modal.styles");
const attributes_1 = require("../../../../client/attributes");
const hooks_1 = require("../../../../client/hooks");
const product_tree_node_1 = require("../../../../client/product-tree-node");
const product_tree_nodes_1 = require("../../../../client/product-tree-nodes");
const table_filter_1 = require("../../../../common/table-filter");
const components_1 = require("../../../../components");
const use_reclassify_hook_1 = require("../../../../hooks/reclassify/use-reclassify.hook");
const hooks_2 = require("../../../../../hooks");
const localization_1 = require("../../../../../localization");
const DeleteNodeModal = ({ open, onClose, selectedProductTreeNode, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addSuccess } = (0, hooks_2.useNotification)();
    const { refetchProductTreeNodes } = (0, hooks_1.useRefetchQueries)();
    const { id, isTerminalNode, title, description, totalProductsCount, path, } = selectedProductTreeNode !== null && selectedProductTreeNode !== void 0 ? selectedProductTreeNode : {};
    const doesParentNodeHaveProducts = totalProductsCount > 0;
    // Ignore the deleted node itself in the path
    const selectedTreeNodeIds = (0, react_1.useMemo)(() => (0, product_tree_nodes_1.getParentTreeNodeIdsFromPath)(path), [path]);
    const { deleteProductTreeNode, loading: isDeletingNode, error: deleteNodeError, } = (0, product_tree_node_1.useDeleteProductTreeNode)();
    const { reclassify } = (0, use_reclassify_hook_1.useReclassify)({ selectedTreeNodePath: path });
    const handleSubmit = () => {
        void deleteProductTreeNode({
            variables: {
                productTreeNode: {
                    clientMutationId: '',
                    id,
                },
            },
            onCompleted: () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    if (isTerminalNode && doesParentNodeHaveProducts) {
                        yield reclassify({
                            filter: {
                                product: {
                                    attributes: [(0, table_filter_1.createProductCategoryFilter)({ search: title })],
                                },
                            },
                            targetCategory: attributes_1.UN_CATEGORIZED_NODE_TITLE,
                        });
                    }
                    else {
                        yield refetchProductTreeNodes(selectedTreeNodeIds);
                    }
                    const successMessageKey = isTerminalNode && doesParentNodeHaveProducts
                        ? 'DELETE_NODE_AND_RECLASSIFY_SUCCESS'
                        : !isTerminalNode ? 'DELETE_NODES_SUCCESS' : 'DELETE_NODE_SUCCESS';
                    addSuccess(t({ key: successMessageKey }));
                    onClose({}, 'escapeKeyDown');
                }
                catch (e) {
                    // Errors are surfaced via the underlying hooks; keep dialog open for retry
                    console.error(e);
                }
            }),
        });
    };
    const handleModalClose = (event, reason) => onClose(event, reason);
    return (react_1.default.createElement(partials_1.StyledTreeActionsDialog, { open: open, onClose: handleModalClose, title: t({ key: 'DELETE_NODE' }), proceedButtonProps: {
            title: t({ key: 'DELETE_ENTITY', values: { entity: '' } }),
            onClick: handleSubmit,
            disabled: isDeletingNode,
            loading: isDeletingNode,
        }, cancelButtonProps: {
            title: t({ key: 'CANCEL' }),
            onClick: () => handleModalClose({}, 'escapeKeyDown'),
            disabled: isDeletingNode,
        } }, react_1.default.createElement(material_1.TextField, { fullWidth: true, disabled: true, InputProps: { readOnly: true }, name: "nodeName", label: t({ key: 'NODE' }), variant: "outlined", value: title }), description && (react_1.default.createElement(material_1.TextField, { fullWidth: true, disabled: true, InputProps: { readOnly: true }, name: "guidelines", label: `${t({ key: 'GUIDELINES' })}`, multiline: true, rows: 4, variant: "outlined", value: description })), react_1.default.createElement(components_1.Alert, { severity: 'warning' }, react_1.default.createElement(material_1.AlertTitle, null, t({ key: 'WARNING' })), react_1.default.createElement(delete_node_modal_styles_1.StyledWarningList, null, isTerminalNode && doesParentNodeHaveProducts && react_1.default.createElement("li", null, t({ key: 'DELETE_NODE_TERMINAL_WARNING', values: { nodeName: title } })), !isTerminalNode && !doesParentNodeHaveProducts && react_1.default.createElement("li", null, t({ key: 'DELETE_NODE_NON_TERMINAL_WARNING', values: { nodeName: title } })), react_1.default.createElement("li", null, t({ key: 'DELETE_NODE_WARNING' })))), deleteNodeError && (react_1.default.createElement(components_1.Alert, { severity: "error" }, t({ key: 'CATALOG_STATE_ERROR' }), react_1.default.createElement("br", null), deleteNodeError.message))));
};
exports.DeleteNodeModal = DeleteNodeModal;
